function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", {
  id: "defs76"
}, /*#__PURE__*/React.createElement("filter", {
  id: "ezoqzdnpia"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  id: "feColorMatrix73",
  values: "0 0 0 0 1.000000 0 0 0 0 0.266667 0 0 0 0 0.121569 0 0 0 1.000000 0",
  in: "SourceGraphic"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-2.2512,-5.2)",
  id: "g92",
  strokeLinecap: "round",
  fillRule: "evenodd",
  fill: "none"
}, /*#__PURE__*/React.createElement("g", {
  id: "g90"
}, /*#__PURE__*/React.createElement("g", {
  id: "g88"
}, /*#__PURE__*/React.createElement("g", {
  id: "g86"
}, /*#__PURE__*/React.createElement("g", {
  id: "g84",
  transform: "translate(-112)"
}, /*#__PURE__*/React.createElement("g", {
  id: "g82",
  strokeWidth: 1.4,
  stroke: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  id: "path78",
  transform: "translate(112)",
  d: "m 14,6 3,4 -3,4",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "path80",
  transform: "translate(112)",
  d: "M 3.592,10 H 17"
})))))));

function SvgGoToArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg94",
    viewBox: "0 0 16.089602 9.6000004",
    height: 9.6000004,
    width: 16.089602,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoToArrow);
export default __webpack_public_path__ + "static/media/go-to-arrow.c08ff5e3.svg";
export { ForwardRef as ReactComponent };